<app-public-header />
<div class="mt-4 d-flex flex-column align-items-center">
  <div *ngIf="loading">
    <p class="lead">Redirecting to your report…</p>
  </div>
  <div *ngIf="!loading && (!!notFoundError || !!expiredError)">
    <p class="lead" *ngIf="notFoundError">
      Report not found, if you need further assistance, please contact us at
      <a href="mailto:info&#64;cfepsurveys.com.au">info&#64;cfepsurveys.com.au</a>
    </p>
    <p class="lead" *ngIf="expiredError">
      Your report link has expired, if you need further assistance, please contact us at
      <a href="mailto:info&#64;cfepsurveys.com.au">info&#64;cfepsurveys.com.au</a>
    </p>
  </div>
</div>
